/**
 * @generated SignedSource<<1e59bd9c91400dd109e1c2476af05798>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type plusWidgetQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"hooksPlusWidgetConfigQuery" | "plusWidgetHasAccessQuery" | "plusWidgetWithoutAccess">;
  readonly " $fragmentType": "plusWidgetQuery";
};
export type plusWidgetQuery$key = {
  readonly " $data"?: plusWidgetQuery$data;
  readonly " $fragmentSpreads": FragmentRefs<"plusWidgetQuery">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "kind": "Variable",
    "name": "applicationId",
    "variableName": "applicationId"
  },
  {
    "kind": "Variable",
    "name": "dailyPulseTypeUuId",
    "variableName": "dailyPulseTypeUuId"
  },
  {
    "kind": "Variable",
    "name": "highlightQueueName",
    "variableName": "highlightQueueName"
  },
  {
    "kind": "Variable",
    "name": "plusNewsAgendaEndDate",
    "variableName": "plusNewsAgendaEndDate"
  },
  {
    "kind": "Variable",
    "name": "plusNewsAgendaStartDate",
    "variableName": "plusNewsAgendaStartDate"
  },
  {
    "kind": "Variable",
    "name": "plusNewsAgendaTypes",
    "variableName": "plusNewsAgendaTypes"
  }
];
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "applicationId"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "dailyPulseTypeUuId"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "highlightQueueName"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "plusNewsAgendaEndDate"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "plusNewsAgendaStartDate"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "plusNewsAgendaTypes"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "plusWidgetQuery",
  "selections": [
    {
      "args": (v0/*: any*/),
      "kind": "FragmentSpread",
      "name": "plusWidgetWithoutAccess"
    },
    {
      "args": (v0/*: any*/),
      "kind": "FragmentSpread",
      "name": "plusWidgetHasAccessQuery"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "hooksPlusWidgetConfigQuery"
    }
  ],
  "type": "Query",
  "abstractKey": null
};
})();

(node as any).hash = "80752b3ef571b8c952db83c2d37ee71b";

export default node;
